import React from 'react';
import PropTypes from 'prop-types';
import masterServicesStrings from 'modules/masterServices/strings';

import {
  Wrapper,
  GridWrapper,
  Header,
  Divider,
  ItemColumn,
  ItemRow,
  ItemText,
  ItemBtn,
  ItemStatusText,
} from './MasterServicesList.style';

const MasterServicesList = ({
  masterServicesListArr,
  handleEditMasterServiceBtnClick,
  handleDeleteMasterServiceBtnClick,
}) => {
  const masterServicesGridHeaderList =
    masterServicesStrings.masterServicesList.masterServicesGridHeader;

  const statusName = {
    active: 'Active',
    inactive: 'In-Active',
  };

  return (
    <Wrapper>
      <GridWrapper>
        <Divider />
        {Object.keys(masterServicesGridHeaderList).map(masterServicesGridHeaderKey => (
          <Header key={masterServicesGridHeaderKey}>
            {masterServicesGridHeaderList[masterServicesGridHeaderKey]}
          </Header>
        ))}
        <Divider />
        {masterServicesListArr?.map(masterService => (
          <React.Fragment key={masterService.masterServiceKey}>
            <ItemColumn>
              <ItemText>{masterService.masterServiceNameEn}</ItemText>
              <ItemText dir="rtl">{masterService.masterServiceNameAr}</ItemText>
            </ItemColumn>
            <ItemColumn>
              <ItemStatusText isActive={masterService.statusKey === 'active'}>
                {statusName[masterService.statusKey]}
              </ItemStatusText>
            </ItemColumn>
            <ItemRow>
              <ItemBtn
                as="button"
                icon={'"\\e90a"'}
                onClick={() => handleEditMasterServiceBtnClick(masterService)}
              />
              <ItemBtn
                as="button"
                icon={'"\\e91f"'}
                onClick={() => handleDeleteMasterServiceBtnClick(masterService)}
              />
            </ItemRow>
            <Divider />
          </React.Fragment>
        ))}
      </GridWrapper>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

MasterServicesList.propTypes = {
  masterServicesListArr: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleEditMasterServiceBtnClick: PropTypes.func.isRequired,
  handleDeleteMasterServiceBtnClick: PropTypes.func.isRequired,
};

MasterServicesList.defaultProps = {};

export default MasterServicesList;
